import { render, staticRenderFns } from "./leaseCardRegister.vue?vue&type=template&id=c57d7c4a&scoped=true&"
import script from "./leaseCardRegister.vue?vue&type=script&lang=js&"
export * from "./leaseCardRegister.vue?vue&type=script&lang=js&"
import style0 from "./leaseCardRegister.vue?vue&type=style&index=0&id=c57d7c4a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c57d7c4a",
  null
  
)

export default component.exports